import clsx from 'clsx'
import React, {memo, useCallback, useRef, useState, useEffect} from 'react'

import {AccordionContext} from './AccordionContext'
import * as classes from './classes'
import type {Props} from './types'

const Accordion = memo<Props>(props => {
  const {
    'data-testid': dataTestId,
    children,
    className,
    defaultValue = false,
    expandBy = 'summary',
    onChange,
    value,
  } = props
  const {current: isControlled} = useRef(typeof value === 'boolean')
  const [stateValue, setStateValue] = useState(defaultValue)

  const isExpanded = isControlled ? Boolean(value) : stateValue

  const toggle = useCallback(() => {
    setStateValue(!isExpanded)
    onChange?.(!isExpanded)
  }, [isExpanded, setStateValue, onChange])

  useEffect(() => {
    if (process.env.NODE_ENV !== 'production' && isControlled !== (typeof value === 'boolean')) {
      console.error(
        `A component is changing the ${isControlled ? '' : 'un'}controlled expended state of Accordion to be ${
          isControlled ? 'un' : ''
        }controlled.`,
      )
    }
  }, [value])

  return (
    <AccordionContext.Provider value={{isExpanded, toggle, expandBy}}>
      <div className={clsx(classes.root, className)} data-testid={dataTestId}>
        {children}
      </div>
    </AccordionContext.Provider>
  )
})

Accordion.displayName = 'Accordion'

export {Accordion}
